import { trace } from 'owa-trace';
import CardDetails from '../store/schema/CardDetails';

/**
 * A map of OAMApp name to card type
 * TODO: Transport this to the server
 */
export const CardOamAppNameMap = {
    XeroOpay: 'Transaction',
};

/**
 * Gets the type of card from the oamappname
 *
 * @param find The oamappname to find
 */
export function getCardType(find: string): string | undefined {
    const t = CardOamAppNameMap[find];
    if (!t) {
        trace.warn(
            `[ActionableMessageDebug] getCardType: Unable to fetch cardType for OamAppName ${find}`
        );
    }

    return t;
}

/**
 * Wrapper function for getCardType for handling extraction of messageCardContext from CardDetails
 *
 * @param {CardDetails} cardDetails the card details object from which to exract the messgaeCardContext
 * @return {string | undefined} a string representing the card type
 */
export function getCardTypeFromCardDetails(cardDetails: CardDetails): string | undefined {
    let cardType = undefined;
    trace.info('[getCardTypeFromCardDetails] Fetching the card type');
    if (cardDetails.card?.messageCardContext) {
        const { messageCardContext } = cardDetails.card;
        cardType = getCardType(messageCardContext.oamAppName) || 'Unknown';
    } else {
        trace.warn(
            '[ActionableMessageDebug] getCardTypeFromCardDetails: Cannot extract the context of an invalid CardDetails object'
        );
    }

    return cardType;
}

/**
 * Function for exposing what we define as the oam provider
 *
 * @param {CardDetails} cardDetails the card details object from which to extract the messageCardContext
 * @return {string | undefined} a string representing the oamapp provider, else undefined iff the
 * messageCardContext object is missing
 */
export function getCardOamAppProvider(cardDetails: CardDetails): string | undefined {
    let oamAppName = undefined;
    trace.info('[getCardOamAppProvider] Fetching the OamAppName');
    if (cardDetails.card?.messageCardContext) {
        const { messageCardContext } = cardDetails.card;
        oamAppName = messageCardContext.oamAppName;
    } else {
        trace.warn(
            '[ActionableMessageDebug] getCardOamAppProvider: Cannot extract oamAppName - messageCardContext is missing'
        );
    }
    return oamAppName;
}
